import React from "react";
import { useStateContext } from "../../context/ContextProvider";
function Button(props) {
  const { currentDir } = useStateContext();
  return (
    <button
      dir="auto"
      className={`${props.Bstyle} ${
        props.Transform
          ? " transition delay-150 duration-300 ease-in-out ltr:hover:translate-x-4 rtl:hover:-translate-x-4 hover:scale-110"
          : ""
      } 
 ${
   props.nonBackground
     ? " text-color-1  "
     : "text-tcolor-4  hover:bg-gray-100 bg-white border border-gray-200 focus:ring-4 focus:outline-none  focus:ring-gray-100 dark:focus:ring-gray-600 dark:bg-back-darktertiary dark:border-gray-700 dark:text-white dark:hover:bg-gray-700  "
 }     font-medium rounded-xl text-sm px-5 py-1.5 text-center inline-flex items-center me-2 mt-2 mb-2  justify-center ${props.icon ? "gap-2"  :""}   `}
    >
      <span
        className={` ${
          props.textStyle ? props.textStyle : "h6 font-semibold"
        } `}
        onClick={props.onClick} >
        {props.text}
      </span>
      <span
        className={`${props.textColor ? props.textColor : ""} ${
          props.iconStyle
        }   ${
          currentDir === "ltr" ? "transform scale-x-[-1]" : ""
        } mt-1`}
      >
        {props.icon}
      </span>
    </button>
  );
}

export default Button;
